import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const NoDataIcon = createIcon({
    viewBox: '0 0 101 100',
    path: (
        <>
            <Path
                fillRule='nonzero'
                d='M50.5 98c26.51 0 48-21.49 48-48S77.01 2 50.5 2s-48 21.49-48 48 21.49 48 48 48zm0 2c-27.614 0-50-22.386-50-50s22.386-50 50-50 50 22.386 50 50-22.386 50-50 50z'
                fill='currentColor'
            />
            <Path
                fillRule='nonzero'
                d='M48.955 40.534c0-.77.692-1.394 1.545-1.394s1.545.624 1.545 1.394v12.99c0 .77-.692 1.394-1.545 1.394s-1.545-.624-1.545-1.394v-12.99zM50.5 61.378c-1.112 0-2.014-.814-2.014-1.817 0-1.004.902-1.818 2.014-1.818 1.112 0 2.014.814 2.014 1.818 0 1.003-.902 1.817-2.014 1.817zm-27.865 8.088c-.861 0-1.408-.832-.994-1.513l27.865-45.955c.43-.709 1.558-.709 1.988 0l27.865 45.955c.414.681-.133 1.513-.994 1.513h-55.73zm1.912-2.045h51.906L50.5 24.62 24.547 67.421z'
                fill='currentColor'
            />
        </>
    ),
})

NoDataIcon.displayName = 'NoDataIcon'
